import { GetPartnerDataTC, GetPartnersListTC, ClaimPartnerRewardTC } from './partner.thunk'

export const partnerAsyncActions = {
  GetPartnerDataTC,
  GetPartnersListTC,
  ClaimPartnerRewardTC,
}
